// SearchComponent.js
import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import SearchIcon from "@mui/icons-material/Search";
import "./style.css";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import TrainIcon from "@mui/icons-material/Train";
import LocalAirportIcon from "@mui/icons-material/LocalAirport";
import HotelIcon from "@mui/icons-material/Hotel";
const SearchComponent = ({
  onSelect,
  placeholder = "Search...",
  apiUrl,
  valueKey = "fullName",
  initialValue,
}) => {
  const [query, setQuery] = useState(initialValue?.[valueKey]);
  const [results, setResults] = useState([]);
  const [selected, setSelected] = useState(initialValue && initialValue);
  const wrapperRef = useRef(null);
  const handleSearch = async (e) => {
    const searchQuery = e.target.value;
    setQuery(searchQuery);
    if (searchQuery.length > 2) {
      try {
        const response = await axios.get(
          process.env.REACT_APP_BACKEND_ZENTRUM +
            `${apiUrl}?term=${searchQuery}`
        );
        setResults(response.data.locationSuggestions);
      } catch (error) {
        console.error("Error fetching search results", error);
      }
    } else {
      setResults([]);
    }
  };

  const handleSelect = (item) => {
    setQuery(item[valueKey]);
    setSelected(item);
    setResults([]);
    onSelect(item); // Return the selected object to the parent
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setResults([]);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const removeFromLastComma = (text) => {
    const lastCommaIndex = text.lastIndexOf(",");
    return lastCommaIndex !== -1 ? text.substring(0, lastCommaIndex) : text;
  };

  return (
    <div className="search-component" ref={wrapperRef}>
      <div className="input-wrapper">
        <SearchIcon />
        <input
          type="text"
          value={query}
          onChange={handleSearch}
          placeholder={placeholder}
          className="searchInput fw-600 fs-10"
        />
      </div>

      {results.length > 0 && (
        <ul className="search-results">
          {results.map((item) => (
            <li
              className="fs-10 d-flex align-items-center"
              key={item.id}
              onClick={() => handleSelect(item)}
              style={{ gap: 6 }}
            >
              <div>
                {item?.type === "MultiCity" ||
                item?.type === "City" ||
                item?.type === "PointOfInterest" ||
                item?.type === "Neighborhood" ? (
                  <LocationOnIcon />
                ) : item?.type === "Hotel" ? (
                  <HotelIcon />
                ) : item?.type === "Airport" ? (
                  <LocalAirportIcon />
                ) : item?.type === "Airport" ? (
                  <TrainIcon />
                ) : (
                  <LocationOnIcon />
                )}
              </div>
              <div>
                <p>
                  {/* {item?.type !== "PointOfInterest"
                    ? item?.name */}
                  {item?.[valueKey]}
                </p>
                <p
                  className="fs-8 ms-1 fw-500"
                  style={{ color: "var(--label-text-color)" }}
                >
                  {item?.state ? item?.state : item?.type}
                  {/* {item?.type} */}
                </p>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SearchComponent;
